import Swiper from 'swiper/bundle';
import Swal from 'sweetalert2';
import Cookies from 'js-cookie';


jQuery(document).ready(function () {
   mobileNavigation();
   initBannerClose();
   ratgeberSlider();
   customFileUploader();
   initRatgeberFilter();
   initAnwaelteSlider();
   faqToggle();
   initReviewSwiper();
   initFormInteractions();
   sidePanel();
   initStatusUpdateHandler();
   initAntragSystem();
   initDashboardTerminSubmit();
});

function mobileNavigation() {
   $('.logo-menu-mobile').on('click', function () {
      $('.mobile-nav-container').addClass('active');
      $('body').addClass('no-scroll'); // add class
   });

   $('.nav-close, .menu-item-129, .menu-item-142, .menu-item-149, .menu-item-154, .menu-item-240').on('click', function () {
      $('.mobile-nav-container').removeClass('active');
      $('body').removeClass('no-scroll'); // remove class
   });
}


function initBannerClose() {
   const banner = $('.app-banner');
   const closeBtn = $('.app-banner__close');
   const cookieName = 'app_banner_closed';

   if (!banner.length) return;

   //  If cookie exists → never show banner
   if (Cookies.get(cookieName) === 'true') {
      banner.remove();
      return;
   }

   // Show banner safely (no flash because display:none in CSS)
   banner.addClass('is-visible');

   // Close button handler
   if (closeBtn.length) {
      closeBtn.on('click', function (e) {
         e.preventDefault();

         // Start hide animation
         banner.addClass('is-hiding').removeClass('is-visible');

         // Save cookie
         Cookies.set(cookieName, 'true', {expires: 7, path: '/'});

         // After animation → fully remove from DOM flow
         setTimeout(function () {
            banner.remove();
         }, 400);
      });
   }
}

function ratgeberSlider() {
   if (jQuery('.rechtsgebiet-swiper').length > 0) {
      const rechtsgebietSwiper = new Swiper('.rechtsgebiet-swiper', {
         // Layout
         slidesPerView: 1,
         spaceBetween: 20,
         loop: true,
         grabCursor: true,
         speed: 1400, // Smooth transition speed
         watchSlidesProgress: true,

         // Soothing Autoplay
         autoplay: {
            delay: 4000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true
         },

         // Enable Horizontal Mousewheel Scrolling
         mousewheel: {
            forceToAxis: true,      // Only scroll horizontally
            releaseOnEdges: true,   // Allow page scroll at start/end
            sensitivity: 1          // Adjust if scrolling feels too fast/slow
         },


         pagination: {
            el: '.swiper-pagination',
            clickable: true,
         },

         // Responsive Breakpoints
         breakpoints: {
            768: {
               slidesPerView: 3,
               spaceBetween: 30
            },
            1200: {
               slidesPerView: 5,
               spaceBetween: 40
            }
         }
      });
   }
   if (jQuery('.ratgeber-post-swiper').length > 0) {
      jQuery('.ratgeber-post-swiper').each(function () {
         const $this = jQuery(this);
         const slideCount = $this.find('.swiper-slide').length;

         // We only want active features if we have 4 or more posts
         const hasEnoughSlides = slideCount >= 4;

         new Swiper(this, {
            slidesPerView: 1,
            spaceBetween: 25,
            autoHeight: false,
            speed: 1000,

            // 1. Logic for Loop & Autoplay
            loop: hasEnoughSlides,
            autoplay: hasEnoughSlides ? {
               delay: 5000,
               disableOnInteraction: false,
            } : false,

            // 2. Logic for Interaction
            grabCursor: hasEnoughSlides,
            watchOverflow: true, // Automatically hides navigation/pagination if not needed

            // 3. Logic for Mousewheel
            mousewheel: hasEnoughSlides ? {
               forceToAxis: true,
               releaseOnEdges: true,
            } : false,

            // 4. Logic for Pagination
            pagination: {
               el: $this.find('.swiper-pagination')[0],
               clickable: true,
            },

            // 5. Explicitly hide pagination via events if count is low
            on: {
               init: function () {
                  if (!hasEnoughSlides) {
                     this.pagination.el.style.display = 'none';
                  }
               }
            },

            breakpoints: {
               768: {
                  slidesPerView: 2,
               },
               1024: {
                  slidesPerView: 3,
               },
               1400: {
                  slidesPerView: 4,
               }
            }
         });
      });
   }
}

function initAnwaelteSlider() {
   // Check if the specific Anwälte wrapper element exists on the page
   if ($('.anwaelte-post-swiper').length > 0) {

      $('.anwaelte-post-swiper').each(function () {
         const $this = $(this);
         const slideCount = $this.find('.swiper-slide').length;

         // Activate structural features (loop, autoplay, mousewheel) only if 3 or more entries exist
         const hasEnoughSlides = slideCount >= 3;

         new Swiper(this, {
            slidesPerView: 1,
            spaceBetween: 30,
            autoHeight: false,
            speed: 1200,

            // 1. Conditional Layout Control Structures
            loop: hasEnoughSlides,
            autoplay: hasEnoughSlides ? {
               delay: 6000,
               disableOnInteraction: false,
               pauseOnMouseEnter: true
            } : false,

            // 2. Client-Side Interaction Layer
            grabCursor: hasEnoughSlides,
            watchOverflow: true, // Gracefully kills pagination nodes if everything fits on one viewport

            // 3. Horizontal Mousewheel Scrolling Directives
            mousewheel: hasEnoughSlides ? {
               forceToAxis: true,
               releaseOnEdges: true,
            } : false,

            // 4. Component Target Hooks
            pagination: {
               el: $this.find('.swiper-pagination')[0],
               clickable: true,
            },

            // 5. Instantly clean up pagination block visibility on small data sets
            on: {
               init: function () {
                  if (!hasEnoughSlides) {
                     this.pagination.el.style.display = 'none';
                  }
               }
            },

            // Responsive Layout Column Definitions
            breakpoints: {
               768: {
                  slidesPerView: 2,
                  spaceBetween: 30
               },
               1200: {
                  slidesPerView: 3.5, // Fits 34crisp profile columns beautifully across a desktop container
                  spaceBetween: 20
               }
            }
         });
      });
   }
}


function customFileUploader() {
   var $realInput = $('.wpcf7-file');

   // Hide the default Contact Form 7 file input
   $realInput.hide();

   // Build HTML with ONLY the button initially
   var customUI = '<div class="custom-upload-container">' +
      '<button type="button" class="btn-choose">' +
      'Wählen <span class="icon-box"><svg width="18" height="22" viewBox="0 0 18 22" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
      '<path d="M4.41068 0.0129591L15.1507 0C15.7041 0.061531 16.2192 0.312385 16.6089 0.710099C16.9985 1.10781 17.2388 1.62795 17.289 2.18247V19.8145C17.2387 20.3772 16.9923 20.9043 16.5928 21.3038C16.1933 21.7033 15.6662 21.9497 15.1035 22H2.18552C1.62293 21.9497 1.09589 21.7034 0.696424 21.3041C0.296961 20.9048 0.0504705 20.3778 0 19.8153L0 5.17755C0.0258285 4.67048 0.208265 4.18389 0.522176 3.78483C1.26423 2.73934 2.06598 1.73754 2.92343 0.784408C3.31308 0.360423 3.83965 0.0872828 4.41068 0.0129591ZM9.43043 8.98601C9.87104 9.27187 10.3963 10.1767 10.9291 10.2148C11.0832 10.2286 11.2378 10.1968 11.374 10.1234C11.5101 10.05 11.6216 9.9382 11.6947 9.80191C11.7678 9.66563 11.7993 9.51086 11.7851 9.35685C11.771 9.20285 11.7119 9.05639 11.6152 8.9357C10.7767 8.26639 9.96938 7.07263 9.13542 6.45593C8.99674 6.34169 8.82265 6.27921 8.64297 6.27921C8.46329 6.27921 8.28921 6.34169 8.15053 6.45593C7.31657 7.07187 6.51082 8.26639 5.67076 8.9357C5.57406 9.05639 5.51497 9.20285 5.50083 9.35685C5.48669 9.51086 5.51812 9.66563 5.59122 9.80191C5.66432 9.9382 5.77586 10.05 5.91198 10.1234C6.0481 10.1968 6.20279 10.2286 6.35683 10.2148C6.89044 10.1767 7.41491 9.27111 7.85552 8.98601V12.7426C7.85552 13.0658 8.35559 13.3677 8.66584 13.3601C8.95704 13.3532 9.42814 13.0414 9.42814 12.7426L9.43043 8.98601ZM4.55628 14.1536C4.37193 14.193 4.2077 14.2969 4.09322 14.4467C3.97874 14.5964 3.92154 14.7821 3.93194 14.9703C3.94233 15.1586 4.01964 15.3369 4.14991 15.4731C4.28019 15.6093 4.45486 15.6945 4.64242 15.7133H12.6466C12.8417 15.6941 13.0226 15.603 13.1543 15.4577C13.2859 15.3125 13.3588 15.1234 13.3588 14.9274C13.3588 14.7313 13.2859 14.5423 13.1543 14.3971C13.0226 14.2518 12.8417 14.1607 12.6466 14.1415L4.55628 14.1536Z" fill="#FBF6F0"/>\n' +
      '</svg>\n</span>' +
      '</button>' +
      '<span class="file-status"></span>' +
      '</div>';

   // Insert the new UI
   $realInput.after(customUI);

   // Link button to hidden input
   $(document).on('click', '.btn-choose', function () {
      $realInput.click();
   });

   // Show filename ONLY when a file is selected
   $realInput.on('change', function () {
      var fileName = $(this).val().split('\\').pop();
      if (fileName) {
         $('.file-status').text(fileName).show();
      } else {
         $('.file-status').hide();
      }
   });
}


function initRatgeberFilter() {
   let currentTerm = 'all';
   let currentPage = 1;

   const $grid = $('#js-ratgeber-grid');
   const $pagination = $('#js-pagination');
   const $loader = $('#js-loader'); // This is your .c-loader-wrapper
   const $section = $('.c-ratgeber-archive');

   // INITIAL LOAD
   loadPosts(1);

   // FILTER CLICK
   $('.c-ratgeber-filter__link').on('click', function (e) {
      e.preventDefault();
      const term = $(this).data('term');
      if ($(this).hasClass('is-active')) return;

      currentTerm = term;
      currentPage = 1;

      $('.c-ratgeber-filter__link').removeClass('is-active');
      $(this).addClass('is-active');

      loadPosts(currentPage);
   });

   // PAGINATION CLICK
   $(document).on('click', '#js-pagination a', function (e) {
      e.preventDefault();
      const href = $(this).attr('href');
      const match = href.match(/paged=(\d+)/);

      if (match) {
         currentPage = parseInt(match[1]);
         loadPosts(currentPage);
      }
   });

   function loadPosts(page) {
      $.ajax({
         url: ajax.url,
         type: 'POST',
         dataType: 'json',
         data: {
            action: 'filter_ratgeber',
            term: currentTerm,
            page: page
         },
         beforeSend: function () {
            // Show loader and dim the grid
            $loader.css('display', 'flex').hide().fadeIn(200);
            $grid.stop().animate({opacity: 0.3}, 300);
         },
         success: function (res) {
            // Update HTML
            $grid.html(res.grid);
            $pagination.html(res.pagination);

            // Transitions
            $grid.stop().animate({opacity: 1}, 300);
            $loader.fadeOut(200);

            // Smooth scroll to top of section on interaction
            if (page > 1 || currentTerm !== 'all') {
               $('html, body').animate({
                  scrollTop: $section.offset().top - 50
               }, 600);
            }
         },
         error: function () {
            $loader.hide();
            $grid.css('opacity', 1);
         }
      });
   }
}


function faqToggle() {

   $('.faq-trigger').on('click', function (e) {
      e.preventDefault();

      var $currentItem = $(this).closest('.faq-item');
      var $currentContent = $currentItem.find('.faq-content');

      if ($currentItem.hasClass('is-active')) {

         $currentContent.slideUp(300, function () {
            $currentItem.removeClass('is-active');
         });

         $(this).attr('aria-expanded', 'false');

      } else {

         $('.faq-item.is-active').each(function () {
            $(this).find('.faq-content').slideUp(300);
            $(this).removeClass('is-active');
            $(this).find('.faq-trigger').attr('aria-expanded', 'false');
         });
         $currentContent.slideDown(300);
         $currentItem.addClass('is-active');

         $(this).attr('aria-expanded', 'true');
      }
   });

}


function initReviewSwiper() {

   const $container = $('.rsr-reviews');

   if ($container.length === 0) return;

   if ($container.hasClass('swiper-initialized')) return;

   $container.addClass('swiper swiper-initialized');

   if (!$container.find('.swiper-wrapper').length) {
      $container.find('.rsr-review')
         .wrapAll('<div class="swiper-wrapper"></div>');
   }

   $container.find('.rsr-review').addClass('swiper-slide');

   if (!$container.find('.swiper-pagination').length) {
      $container.append('<div class="swiper-pagination"></div>');
   }

   // init swiper
   new Swiper('.rsr-reviews', {
      slidesPerView: 1,
      spaceBetween: 20,
      loop: true,
      grabCursor: true,
      autoplay: {
         delay: 4000
      },
      pagination: {
         el: '.custom-pill-dots',
         clickable: true,
      },
   });
}


function initFormInteractions() {
   $('.input-group').each(function () {
      const $group = $(this);
      const $input = $group.find('input');
      const $toggle = $group.find('.password-toggle');

      // Check state on load
      if ($input.val() !== "") $group.addClass('has-value');

      // Floating Labels & Instant Validation
      $input.on('focus blur keyup', function (e) {
         // Label Toggle
         if (e.type === 'focus' || $(this).val() !== "") {
            $group.addClass('has-value');
         } else {
            $group.removeClass('has-value');
         }

         // Instant Validation on blur/keyup
         if (e.type !== 'focus') {
            $group.find('.instant-error').remove();
            let error = "";

            if ($(this).attr('type') === 'email' && $(this).val().length > 0) {
               if (!$(this).val().includes('@')) {
                  error = "Ungültige E-Mail.";
               }
            }
            if ($(this).attr('id') === 'user_pass_confirm' && $(this).val() !== $('#user_pass').val()) {
               error = "Keine Übereinstimmung.";
            }

            if (error) {
               $group.append('<span class="field-error instant-error">' + error + '</span>');
               $group.addClass('has-error');
            } else {
               $group.removeClass('has-error');
            }
         }
      });

      // Password Toggle
      $toggle.on('click', function (e) {
         e.preventDefault();
         const isPass = $input.attr('type') === 'password';
         $input.attr('type', isPass ? 'text' : 'password');
         // Toggle icons
         $(this).find('.icon-show').toggle(!isPass);
         $(this).find('.icon-hide').toggle(isPass);
         // Optional class
         $(this).toggleClass('is-visible', isPass);
         $input.trigger('focus');
      });
   });
}


function sidePanel() {
   $('.notif-nav-btn').on('click', function (e) {
      e.preventDefault(); // Prevents jump if it's an <a> tag

      const $this = $(this);
      const $badge = $this.find('.notif-badge');

      // 1. UI: Remove the badge only if it exists
      if ($badge.length > 0) {
         $badge.fadeOut(200, function () {
            $(this).remove();
         });

         // 2. Database: Only call the server if there was a badge to clear
         $.post(ajax.url, {
            action: 'mark_antrag_read',
            security: ajax.chat_nonce
         }, function (response) {
            if (response.success) {
               console.log("Notifications updated.");
            }
         });
      }

      // 3. UI: Open the sidebar
      $('.side-panel, .drawer-overlay').addClass('is-visible');
   });

   $('.panel-close, .drawer-overlay').on('click', function () {
      $('.side-panel, .drawer-overlay').removeClass('is-visible');
   });
}

function initStatusUpdateHandler() {
   $('.status-update-btn').on('click', function (e) {
      e.preventDefault();

      const $btn = $(this);
      const targetStatus = $btn.data('status');
      const statusLabel = $btn.data('label');

      // Find the ID from the parent wrapper
      const antragId = $btn.closest('.lawyer-function-wrapper').data('post-id');

      Swal.fire({
         title: statusLabel + '?',
         text: "Möchten Sie den Status auf '" + statusLabel + "' ändern?",
         icon: 'question',
         showCancelButton: true,
         confirmButtonColor: '#F87060',
         confirmButtonText: 'Ja, ändern',
         cancelButtonText: 'Abbrechen'
      }).then((result) => {
         if (result.isConfirmed) {
            $.ajax({
               type: 'POST',
               url: ajax.url, // Correctly using the 'ajax' object URL
               data: {
                  action: 'update_antrag_status_action',
                  post_id: antragId,
                  target_status: targetStatus,
                  security: ajax.status_nonce
               },
               beforeSend: function () {
                  $btn.prop('disabled', true).text('Speichere...');
               },
               success: function (response) {
                  if (response.success) {
                     Swal.fire('Erfolg', response.data, 'success').then(() => {
                        window.location.reload();
                     });
                  } else {
                     Swal.fire('Fehler', response.data, 'error');
                     $btn.prop('disabled', false).text(statusLabel);
                  }
               },
               error: function () {
                  Swal.fire('Fehler', 'Die Verbindung zum Server ist fehlgeschlagen.', 'error');
                  $btn.prop('disabled', false).text(statusLabel);
               }
            });
         }
      });
   });
}

function initAntragSystem() {
   const $wrapper = $('.news-col');
   if (!$wrapper.length) return;

   const postID = $wrapper.data('post-id');

   // --- 1. NOTIFICATION SIDEBAR SYNC ---
   $(document).on('click', '#open-sidebar-btn, .navbar-notification-icon', function () {
      $.post(ajax.url, {
         action: 'mark_antrag_read',
         security: ajax.chat_nonce
      }, function (res) {
         if (res.success) {
            $('.notif-badge').fadeOut();
         }
      });
   });


   // --- 2. UI: MODAL TOGGLES ---
   $(document).on('click', '#message-compose-btn', function (e) {
      e.preventDefault();
      $('#messageModal').addClass('active');
   });

   $(document).on('click', '.openTerminModal', function (e) {
      e.preventDefault();
      // If triggered from an existing appointment request, we might want to pass the ID
      const commentID = $(this).data('comment-id');
      $('#terminModal').find('form').attr('data-reschedule-id', commentID);
      $('#terminModal').addClass('active');
   });

   $('.modal-overlay').on('click', function (e) {
      if (e.target === this || $(e.target).hasClass('close-x')) {
         $(this).removeClass('active');
      }
   });

   // --- 3. DATA: SEND NEW MESSAGE ---
   $('#messageForm').on('submit', function (e) {
      e.preventDefault();
      const $form = $(this);
      const $btn = $form.find('button[type="submit"]');
      const messageVal = $('#nachricht').val();
      const msgType = $form.find('input[name="msg_type"]').val() || 'antrag_chat';

      if (!messageVal.trim()) return;

      $.ajax({
         type: 'POST',
         url: ajax.url,
         data: {
            action: 'send_antrag_message',
            security: ajax.chat_nonce,
            post_id: postID,
            message: messageVal,
            msg_type: msgType
         },
         beforeSend: () => $btn.prop('disabled', true).text('Wird gesendet...'),
         success: (res) => {
            if (res.success) {
               Swal.fire({icon: 'success', title: 'Erfolgreich gesendet!', timer: 1000, showConfirmButton: false})
                  .then(() => location.reload());
            } else {
               Swal.fire('Fehler', 'Fehler beim Senden', 'error');
               $btn.prop('disabled', false).text('Nachricht senden');
            }
         }
      });
   });

   // --- 4. DATA: SEND NEW APPOINTMENT PROPOSAL ---
   $('#terminForm').on('submit', function (e) {
      e.preventDefault();
      const $btn = $(this).find('button[type="submit"]');

      $.ajax({
         type: 'POST',
         url: ajax.url,
         data: {
            action: 'send_antrag_termin',
            security: ajax.chat_nonce,
            post_id: postID,
            datum: $('#datum').val(),
            uhrzeit: $('#uhrzeit').val(),
            telefon: $('#telefon').val()
         },
         beforeSend: () => $btn.prop('disabled', true).text('Wird gesendet...'),
         success: (res) => {
            if (res.success) {
               Swal.fire({icon: 'success', title: 'Termin vorgeschlagen!', timer: 1000, showConfirmButton: false})
                  .then(() => location.reload());
            } else {
               Swal.fire('Fehler', 'Fehler beim Speichern', 'error');
               $btn.prop('disabled', false).text('Anfrage senden');
            }
         },
         error: (xhr) => {
            // This will help you see WHY the 400 error is happening
            console.log(xhr.responseText);
            Swal.fire('Fehler', 'Server Status 400: Überprüfen Sie die Konsole', 'error');
            $btn.prop('disabled', false).text('Anfrage senden');
         }
      });
   });

   // --- 5. ACTIONS: VERTRETUNG DECISIONS ---
   $(document).on('click', '.confirm-vertretung', function (e) {
      e.preventDefault();
      const $btnContainer = $(this).closest('.accept-reject-btns');
      const commentID = $(this).data('comment-id');

      Swal.fire({
         title: 'Vertretung bestätigen?',
         text: "Möchten Sie sich offiziell vertreten lassen?",
         icon: 'question',
         showCancelButton: true,
         confirmButtonColor: '#2ecc71',
         confirmButtonText: 'Ja, bestätigen'
      }).then((result) => {
         if (result.isConfirmed) {
            $.post(ajax.url, {
               action: 'confirm_antrag_vertretung',
               security: ajax.chat_nonce,
               comment_id: commentID
            }, (res) => {
               if (res.success) {
                  $btnContainer.fadeOut(200, function () {
                     $(this).html('<div class="decision-status">✅ Vertretung wurde bestätigt.</div>').fadeIn();
                  });
                  setTimeout(() => {
                     location.reload();
                  }, 1000); // Reload is essential for log bubble
               }
            });
         }
      });
   });

   $(document).on('click', '.decline-vertretung', function (e) {
      e.preventDefault();
      const $btnContainer = $(this).closest('.accept-reject-btns');
      const commentID = $(this).data('comment-id');

      $.post(ajax.url, {
         action: 'decline_antrag_vertretung',
         security: ajax.chat_nonce,
         comment_id: commentID
      }, (res) => {
         if (res.success) {
            $btnContainer.fadeOut(200, function () {
               $(this).html('<div class="decision-status">❌ Vertretung wurde abgelehnt.</div>').fadeIn();
            });
            setTimeout(() => {
               location.reload();
            }, 1000);
         }
      });
   });

   // --- 6. ACTIONS: TERMIN DECISIONS ---
   $(document).on('click', '.confirm-termin', function (e) {
      e.preventDefault();
      const $btnContainer = $(this).closest('.termin-btns-wrapper');
      const commentID = $(this).data('comment-id');

      $.post(ajax.url, {
         action: 'confirm_antrag_termin',
         security: ajax.chat_nonce,
         post_id: postID,
         comment_id: commentID
      }, (res) => {
         if (res.success) {
            $btnContainer.fadeOut(200, function () {
               // Adjusted text to be generic before reload
               $(this).html('<div class="decision-status">✅ Zugesagt.</div>').fadeIn();
            });
            setTimeout(() => {
               location.reload();
            }, 800);
         }
      });
   });

   $(document).on('click', '.decline-only-termin', function (e) {
      e.preventDefault();
      const $btnContainer = $(this).closest('.termin-btns-wrapper');
      const commentID = $(this).data('comment-id');

      $.post(ajax.url, {
         action: 'decline_antrag_termin',
         security: ajax.chat_nonce,
         post_id: postID,
         comment_id: commentID
      }, (res) => {
         if (res.success) {
            $btnContainer.fadeOut(200, function () {
               $(this).html('<div class="decision-status">❌ Abgelehnt.</div>').fadeIn();
            });
            setTimeout(() => {
               location.reload();
            }, 800);
         }
      });
   });

   $(document).on('click', '#trigger-reupload', function (e) {
      e.preventDefault();
      $('#antrag-file-input').click();
   });

// Handle upload
   $(document).on('change', '#antrag-file-input', function () {
      const fileInput = this;
      const fileData = fileInput.files[0];
      const $feedback = $('#upload-feedback');

      if (!fileData) return;

      // Get ID from <div class="data-col" data-post-id="...">
      const postId = $(fileInput).closest('.data-col').data('post-id');

      const formData = new FormData();
      formData.append('action', 'replace_antrag_file');
      formData.append('post_id', postId);
      formData.append('new_file', fileData);
      formData.append('security', ajax.chat_nonce);

      // 1. Show Loading UI
      $feedback.text('⏳ Dokument wird gesendet...').css('color', '#666');

      Swal.fire({
         title: 'Dokument wird hochgeladen',
         text: 'Bitte haben Sie einen Moment Geduld.',
         allowOutsideClick: false,
         showConfirmButton: false,
         didOpen: () => {
            Swal.showLoading();
         }
      });

      $.ajax({
         url: ajax.url,
         type: 'POST',
         data: formData,
         contentType: false,
         processData: false,
         xhr: function () {
            var xhr = new window.XMLHttpRequest();
            xhr.upload.addEventListener("progress", function (evt) {
               if (evt.lengthComputable) {
                  var percent = Math.round((evt.loaded / evt.total) * 100);
                  $feedback.text('📤 Fortschritt: ' + percent + '%').css('color', '#1CB61C');
               }
            }, false);
            return xhr;
         },
         success: function (res) {
            if (res.success) {
               $feedback.text('✅ Dokument erfolgreich hinzugefügt!').css('color', '#1CB61C');

               Swal.fire({
                  icon: 'success',
                  title: 'Erfolgreich!',
                  text: 'Das Dokument wurde zur Liste hinzugefügt.',
                  timer: 1500,
                  showConfirmButton: false
               }).then(() => {
                  // Reset the input so the same file can be uploaded again if needed
                  $(fileInput).val('');
                  location.reload();
               });
            } else {
               $feedback.text('❌ ' + res.data).css('color', '#F87060');
               Swal.fire({
                  icon: 'error',
                  title: 'Fehler',
                  text: res.data,
                  confirmButtonColor: '#F87060'
               });
               $(fileInput).val(''); // Clear on error too
            }
         },
         error: function () {
            $feedback.text('❌ Systemfehler.').css('color', '#F87060');
            Swal.fire({
               icon: 'error',
               title: 'Verbindungsfehler',
               text: 'Der Server konnte nicht erreicht werden.',
               confirmButtonColor: '#F87060'
            });
            $(fileInput).val('');
         }
      });
   });
}

/**
 * Handles the Appointment Proposal Form on the Lawyer Dashboard
 */
function initDashboardTerminSubmit() {
   const $form = jQuery('#dashboardTerminForm');

   if (!$form.length) return;

   const $date = $form.find('[name="datum"]');
   const $time = $form.find('[name="uhrzeit"]');
   const $btn = $form.find('.btn-submit');
   const originalBtnText = $btn.text();

   // 🔴 error messages under fields
   const $dateMsg = $('<div class="field-message" style="color:#e89393;font-size:13px;margin-top:5px;"></div>');
   const $timeMsg = $('<div class="field-message" style="color:#e89393;font-size:13px;margin-top:5px;"></div>');

   $date.after($dateMsg);
   $time.after($timeMsg);

   function validateDate() {
      const val = $date.val();
      if (!val) return false;

      const d = new Date(val);
      const day = d.getDay();

      if (day === 0 || day === 6) {
         $dateMsg.text('Telefontermine nur Montag bis Freitag möglich.');
         return false;
      }

      $dateMsg.text('');
      return true;
   }

   function validateTime() {
      const val = $time.val();
      if (!val) return false;

      const [h, m] = val.split(':').map(Number);
      const total = h * 60 + m;

      if (total < 480 || total > 1080) {
         $timeMsg.text('Nur Zeiten zwischen 08:00 und 18:00 erlaubt.');
         return false;
      }

      $timeMsg.text('');
      return true;
   }

   // 🔥 instant feedback
   $date.on('change', validateDate);
   $time.on('change', validateTime);

   $form.on('submit', function (e) {
      e.preventDefault();

      const okDate = validateDate();
      const okTime = validateTime();

      // ❌ STOP if invalid
      if (!okDate || !okTime) return;

      const formData = {
         action: 'send_antrag_termin',
         security: ajax.chat_nonce,
         post_id: $form.find('[name="post_id"]').val(),
         datum: $date.val(),
         uhrzeit: $time.val()
      };

      $btn.prop('disabled', true).text('Vorschlag wird gesendet...');

      jQuery.ajax({
         url: ajax.url,
         type: 'POST',
         data: formData,

         success: function (response) {
            if (response.success) {
               Swal.fire({
                  title: 'Gesendet!',
                  text: 'Der Terminvorschlag wurde erfolgreich übermittelt.',
                  icon: 'success',
                  confirmButtonColor: '#102542'
               }).then(() => {
                  location.reload();
               });
            } else {
               Swal.fire(
                  'Fehler',
                  response.data?.message || 'Konnte nicht gesendet werden.',
                  'error'
               );
               $btn.prop('disabled', false).text(originalBtnText);
            }
         },

         error: function () {
            Swal.fire('Fehler', 'Serververbindung fehlgeschlagen.', 'error');
            $btn.prop('disabled', false).text(originalBtnText);
         }
      });
   });
}



